module.exports = __webpack_public_path__ + "static/media/play-being-dead.5f469541.mp3";